"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _i18n = require("@active/react-utils/i18n");
var _ReservedOptions = require("../Dropdown/ReservedOptions");
var Placeholder = function Placeholder(_ref) {
  var children = _ref.children;
  var _useLocale = (0, _i18n.useLocale)(),
    i18n = _useLocale.i18n;
  return /*#__PURE__*/_react["default"].createElement("option", {
    disabled: true,
    value: _ReservedOptions.ReservedOptions.PLACEHOLDER,
    "data-testid": "native-dropdown-placeholder"
  }, i18n(children));
};
var _default = exports["default"] = Placeholder;